var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGrayScaleSvgEon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 85,
    viewBox: "0 0 448 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_3499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 85.0002V1.14502H12.1673V74.6971H52.4411V85.0002H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.703 84.9999L107.559 67.3131H74.4028L67.8325 84.9999H54.2051L90.4028 0H93.6271L127.209 84.9999H113.703ZM91.437 21.9798L77.6271 58.8989H104.091L91.437 21.9798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.745 52.717V84.9998H136.578V1.14466C145.785 0.763064 151.341 0.572266 153.247 0.572266C179.123 0.572266 192.061 8.71928 192.061 25.0133C192.061 43.864 180.624 53.2894 157.749 53.2894C156.37 53.2894 153.369 53.0986 148.745 52.717ZM148.745 11.4477V42.414C153.896 42.7956 156.614 42.9864 156.898 42.9864C171.985 42.9864 179.529 37.396 179.529 26.2153C179.529 15.9886 171.478 10.8753 155.377 10.8753C153.754 10.8753 151.544 11.0661 148.745 11.4477Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.053 74.6968V84.9998H259.285V74.6968H206.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.053 56.2573V65.9879H247.665V56.2573H206.053Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.053 37.2451V47.5481H259.285V37.2451H206.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.318 19.481V29.2116H247.931V19.481H206.318Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.053 1.14453V11.4476H259.285V1.14453H206.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.738 84.9998H272.791V1.14466C284.228 0.763064 291.549 0.572266 294.753 0.572266C307.204 0.572266 317.06 4.14016 324.32 11.276C331.579 18.3736 335.209 27.8371 335.209 39.6665C335.209 69.8887 320.385 84.9998 290.738 84.9998ZM284.958 11.4477V74.1244C287.676 74.506 291.042 74.6968 295.057 74.6968C303.574 74.6968 310.266 71.7013 315.133 65.7103C320 59.6811 322.434 51.3242 322.434 40.6396C322.434 20.7967 312.963 10.8753 294.023 10.8753C292.887 10.8753 289.866 11.0661 284.958 11.4477Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.33 85.0002V1.14502H363.497V85.0002H351.33Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.494 84.9999L428.35 67.3131H395.194L388.623 84.9999H374.996L411.194 0H414.418L448 84.9999H434.494ZM412.228 21.9798L398.418 58.8989H424.882L412.228 21.9798Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_3499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 448,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrayScaleSvgEon);
export default __webpack_public_path__ + "static/media/logoGrayScaleSvgEON.aaa34692105ab2807a748f88e9c22d43.svg";
export { ForwardRef as ReactComponent };